import { createSlice } from '@reduxjs/toolkit';

export interface TabsSyncState {
	initStateReceived: boolean;
}

const tabsSyncSlice = createSlice({
	name: 'tabsSync',
	initialState: {
		initStateReceived: false
	},
	reducers: {}
});

export default tabsSyncSlice.reducer;
